<template>
  <div>
    <div class="changebtn" v-if="!showPwdForm">
      <div
        class="register-btn phone-btn"
        :class="{ 'phone-btn-active': regType == 'phone' }"
        @click="regType = 'phone'"
      >
        <i></i>
        <span>{{ $t("nav.w61") }}</span>
      </div>
      <div
        class="register-btn email-btn"
        :class="{ 'email-btn-active': regType == 'email' }"
        @click="regType = 'email'"
      >
        <i></i>
        <span>{{ $t("nav.w62") }}</span>
      </div>
    </div>
    <div class="formbox">
      <Form
        v-show="regType == 'phone' && !showPwdForm"
        :model="phoneForm"
        label-position="top"
        :rules="phoneFormRule"
        ref="phoneForm"
      >
        <FormItem :label="$t('label.w40')" prop="phone">
          <Input
            v-model="phoneForm.phone"
            :placeholder="$t('pl.p7')"
            @on-change="inputChange"
            name="phone"
          >
            <Select
              v-model="phoneForm.areacode"
              slot="prepend"
              style="width: 80px"
            >
              <Option value="0086">0086</Option>
              <Option value="00852">00852</Option>
            </Select>
          </Input>
        </FormItem>
        <FormItem :label="$t('label.w35')" prop="code">
          <Row type="flex" :gutter="10">
            <Col span="15">
              <Input v-model="phoneForm.code" :placeholder="$t('pl.p8')" />
            </Col>
            <Col span="9">
              <Codebtn
                type="regPhone"
                :to="phoneForm.phone"
                :btndisabled="btndisabled"
              />
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="$t('label.w207')" prop="inviteCode">
          <Input v-model="phoneForm.inviteCode" :placeholder="$t('pl.p33')" />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            :style="{ marginTop: '50px' }"
            long
            :disabled="
              !phoneForm.phone || !phoneForm.code || !phoneForm.inviteCode
            "
            @click="gonext"
            >{{ $t("btn.b4") }}</Button
          >
        </FormItem>
      </Form>

      <Form
        v-show="regType == 'email' && !showPwdForm"
        :model="emailForm"
        label-position="top"
        :rules="emailFormRule"
        ref="emailForm"
      >
        <FormItem :label="$t('label.w45')" prop="email">
          <Input
            v-model="emailForm.email"
            :placeholder="$t('pl.p9')"
            @on-change="inputChange"
            name="email"
          />
        </FormItem>
        <FormItem :label="$t('label.w36')" prop="code">
          <Row type="flex" :gutter="10">
            <Col span="15">
              <Input v-model="emailForm.code" :placeholder="$t('pl.p8')" />
            </Col>
            <Col span="9">
              <Codebtn
                type="regEmail"
                :to="emailForm.email"
                :btndisabled="btndisabled"
              />
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="$t('label.w207')" prop="inviteCode">
          <Input v-model="emailForm.inviteCode" :placeholder="$t('pl.p33')" />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            :style="{ marginTop: '50px' }"
            long
            :disabled="
              !emailForm.email || !emailForm.code || !emailForm.inviteCode
            "
            @click="gonext"
            >{{ $t("btn.b4") }}</Button
          >
        </FormItem>
      </Form>

      <Form
        v-if="showPwdForm"
        :model="pwdForm"
        label-position="top"
        :rules="pwdFormRule"
        ref="pwdForm"
      >
        <FormItem :label="$t('label.w20')" prop="pwd">
          <Input
            type="password"
            v-model="pwdForm.pwd"
            :placeholder="$t('pl.p3')"
            :maxlength="16"
          />
        </FormItem>
        <FormItem :label="$t('label.w34')" prop="pwdagain">
          <Input
            type="password"
            v-model="pwdForm.pwdagain"
            :placeholder="$t('pl.p4')"
            :maxlength="16"
          />
        </FormItem>
        <div>
          <Checkbox v-model="agree" label="Eat" :style="{ marginRight: 0 }">
            {{ $t("other.w63") }}
            <a href="javascript:;" @click="protocolShow([4, 5])">{{
              $t("other.w118")
            }}</a>
            <a href="javascript:;" @click="protocolShow([5, 4])">{{
              $t("other.w119")
            }}</a>
          </Checkbox>
        </div>
        <FormItem>
          <Button
            type="primary"
            :style="{ marginTop: '35px' }"
            long
            :disabled="!pwdForm.pwd || !pwdForm.pwdagain || !agree"
            :loading="isDisable"
            @click="submit"
            >{{ $t("btn.b11") }}</Button
          >
        </FormItem>
      </Form>
    </div>
    <div class="loginlink" v-if="!showPwdForm">
      <span>{{ $t("msg.m9") }}</span>
      <router-link :to="{ name: 'login' }">{{ $t("btn.b10") }}</router-link>
    </div>
    <Protocol ref="Protocol" @yes="agree = true" @no="agree = false" />
  </div>
</template>

<script>
import formRule from "../../libs/formRule"
import Codebtn from "@/components/sendCodeBtn"
import Protocol from "@/components/protocolModal"
import Rsa from "@/libs/Rsa"
import { post } from "@/libs/axios"
import Exp from "@/libs/Exp"
export default {
  components: { Codebtn, Protocol },
  data() {
    return {
      agree: false,
      regType: "phone",
      btndisabled: true,
      isDisable: false,
      phoneForm: {
        areacode: "0086",
        phone: "",
        code: "",
        inviteCode: "",
      },
      phoneFormRule: {
        inviteCode: [
          { required: true, message: this.$t("msg.m136"), trigger: "blur" },
          // {
          //   validator: (rule, value, callback) => {
          //     if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6}$/.test(value)) {
          //       return callback(new Error(this.$t("msg.m137")))
          //     } else {
          //       callback()
          //     }
          //   },
          //   trigger: "submit",
          // },
        ],

        code: formRule.code,
        phone: [
          { required: true, message: this.$t("msg.m26"), trigger: "submit" },
          {
            validator: (rule, value, callback) => {
              // if(!/^[0-9]+$/.test(value)) return callback(new Error(this.$t('msg.m27')));
              if (this.phoneForm.areacode == "0086") {
                if (!Exp.cnPhone.test(value))
                  return callback(new Error(this.$t("msg.m27")))
              }
              if (this.phoneForm.areacode == "00852") {
                if (!Exp.hkPhone.test(value))
                  return callback(new Error(this.$t("msg.m27")))
              }
              // 判断手机是否被使用
              post("/Member/RZJAuth/IsExistMobliePhone", {
                mobliePhone: value,
              }).then((res) => {
                // if(!res.IsExistMobliePhone){
                // this.btndisabled=false
                // }
                if (res.IsExistMobliePhone) {
                  // this.btndisabled=true;
                  callback(new Error(this.$t("msg.m69")))
                } else callback()
              })
            },
            trigger: "submit",
          },
        ],
      },

      emailForm: {
        email: "",
        code: "",
        inviteCode: "",
      },
      emailFormRule: {
        // inviteCode: [
        //   { required: true, message: this.$t("msg.m136"), trigger: "blur" },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6}$/.test(value)) {
        //         return callback(new Error(this.$t("msg.m137")))
        //       } else {
        //         callback()
        //       }
        //     },
        //     trigger: "submit",
        //   },
        // ],
        email: [
          { required: true, message: this.$t("msg.m70"), trigger: "submit" },
          { type: "email", message: this.$t("msg.m71"), trigger: "submit" },
          {
            validator: (rule, value, callback) => {
              // 判断邮箱是否被使用
              post("/Member/RZJAuth/IsExistEmail", {
                email: value,
              }).then((res) => {
                if (res.err) return res.throw()
                // if (!res.IsExistEmail) this.btndisabled=false
                if (res.IsExistEmail) {
                  // this.btndisabled=true;
                  callback(new Error(this.$t("msg.m72")))
                } else callback()
              })
            },
            trigger: "submit",
          },
        ],
        code: formRule.code,
      },

      showPwdForm: false,
      pwdForm: {
        pwd: "",
        pwdagain: "",
      },
      pwdFormRule: {
        pwd: formRule.logPwd,
        pwdagain: [
          { required: true, message: this.$t("msg.m6"), trigger: "submit" },
          {
            validator: (rule, value, callback) => {
              if (value != this.pwdForm.pwd)
                callback(new Error(this.$t("msg.m7")))
              else callback()
            },
            trigger: "submit",
          },
        ],
      },
    }
  },
  mounted() {
    // this.getinviteId()
  },
  methods: {
    // getinviteId(){
    //   this.inviteCode = this.$geturlkey.getUrlKey('inviteId');
    // },
    inputChange(e) {
      let { name, value } = e.target
      if (name === "phone") {
        let re = false
        if (this.phoneForm.areacode == "0086") {
          re = !Exp.cnPhone.test(value)
        }
        if (this.phoneForm.areacode == "00852") {
          re = !Exp.hkPhone.test(value)
        }
        this.$nextTick(() => {
          this.btndisabled = re
        })
      } else if (name == "email") {
        let re = false
        re = !Exp.email.test(value)
        this.$nextTick(() => {
          this.btndisabled = re
        })
      }
    },
    // 下一步
    async gonext() {
      let regType = this.regType
      // 提交前验证表单
      let valid = await this.$refs[
        regType == "phone" ? "phoneForm" : "emailForm"
      ].validate()
      if (!valid) return

      let pm
      if (regType == "phone") {
        pm = this.$axios.post("/Member/RZJAuth/VerifRegisterPhoneCode", {
          mobliePhone: this.phoneForm.phone,
          code: this.phoneForm.code,
          inviteId: this.phoneForm.inviteCode,
        })
      } else if (regType == "email") {
        pm = this.$axios.post("/Member/RZJAuth/VerifRegisterEmailCode", {
          email: this.emailForm.email,
          code: this.emailForm.code,
          inviteId: this.emailForm.inviteCode,
        })
      }
      pm.then((res) => {
        if (res.err) return res.throw()
        this.showPwdForm = true
      })
    },
    // 提交注册
    async submit() {
      this.isDisable = true
      let regType = this.regType
      let valid = await this.$refs["pwdForm"].validate()
      if (!valid) return

      let pm
      if (regType == "phone") {
        pm = this.$axios.post("/Member/RZJAuth/MobliePhoneRegister", {
          phoneAreaCode: this.phoneForm.areacode,
          mobliePhone: this.phoneForm.phone,
          code: this.phoneForm.code,
          passWord: Rsa(this.pwdForm.pwd),
          affirmPassWord: Rsa(this.pwdForm.pwdagain),
          inviteId: this.phoneForm.inviteCode,
        })
      } else if (regType == "email") {
        pm = this.$axios.post("/Member/RZJAuth/EmailRegister", {
          email: this.emailForm.email,
          code: this.emailForm.code,
          passWord: Rsa(this.pwdForm.pwd),
          affirmPassWord: Rsa(this.pwdForm.pwdagain),
          inviteId: this.emailForm.inviteCode,
        })
      }
      pm.then((res) => {
        this.isDisable = false
        if (res.err) return res.throw()
        this.$Message.success(this.$t("msg.m73"))
        this.$router.push("login")
      })
    },
    protocolShow(arr) {
      this.$refs.Protocol.type = arr
      this.$refs.Protocol.modal = true
    },
  },
  computed: {
    areacode() {
      return this.phoneForm.areacode
    },
    phone() {
      return this.phoneForm.phone
    },
    email() {
      return this.emailForm.email
    },
  },
  watch: {
    // 类型切换时回到第一步
    regType() {
      this.showPwdForm = false
      this.btndisabled = true
      this.$refs.phoneForm.resetFields()
      this.$refs.emailForm.resetFields()
      if (this.$refs.pwdForm) this.$refs.pwdForm.resetFields()
    },
    areacode() {
      this.$refs.phoneForm.resetFields()
    },
    phone() {
      this.btndisabled = true
    },
    email() {
      this.btndisabled = true
    },
  },
}
</script>

<style lang="less" scoped>
.changebtn {
  display: flex;
  cursor: pointer;
  width: 250px;
  height: 32px;
  background: rgba(228, 235, 248, 1);
  border-radius: 16px;
  margin: 0 auto 35px;
  .register-btn {
    width: 122px;
    height: 28px;
    margin-top: 2px;
    margin-left: 2px;
    border-radius: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      width: 14px;
      height: 14px;
      display: inline-block;
      margin-right: 8px;
      background: url("../../assets/login_icon14x14.png") no-repeat;
      background-size: cover;
    }
    span {
      font-size: 12px;
      font-weight: 500;
      color: #65718a;
    }
  }
  .phone-btn {
    i {
      background-position: 0 -70px;
    }
    span {
      margin-top: -2px;
    }
  }
  .email-btn {
    i {
      background-position: 0 -98px;
    }
  }
  .phone-btn-active {
    background: #fff;
    i {
      background-position: 0 -56px;
    }
    span {
      color: #232325;
    }
  }
  .email-btn-active {
    background: #fff;
    i {
      background-position: 0 -84px;
    }
    span {
      color: #232325;
    }
  }
}
.formbox {
  width: 300px;
}
.loginlink {
  margin-top: 30px;
  font-size: 14px;
  text-align: center;
  color: #7b7b7c;
  a {
    color: #5e8ffc;
  }
}
</style>
